import {
    kedDescription,
    kedV2Description,
    pedDescription,
    spcDescription,
    znDescription
} from "../../../components/user/learning-course/dashboard/CourseDescriptions";
import {
    kedCourseStructure,
    kedV2CourseStructure,
    LearningCourseWeek,
    pedCourseStructure,
    spcCourseStructure,
    znCourseStructure
} from "./LearningCourse";
import {AvailableCourses} from "./AvailableCourses";

export class CourseDetails {
    key: AvailableCourses;
    fullName: string
    welcomeMessage: string;
    length: string;
    structure: LearningCourseWeek[];
    description: JSX.Element;
    dashboardUrl: string;
    introVideoUrl?: string;

    static KED = new CourseDetails(AvailableCourses.KED, 'Kurs Efektywnego Działania', 'Witamy na Kursie Efektywnego Działania!', '9 tygodni', kedCourseStructure,
        kedDescription, '/produkt/kurs-efektywnego-dzialania');
    static KED_V2 = new CourseDetails(AvailableCourses.KED_V2, 'Kurs Efektywnego Działania 2.0', 'Witamy na Kursie Efektywnego Działania 2.0!', '6 tygodni', kedV2CourseStructure,
        kedV2Description, '/produkt/kurs-efektywnego-dzialania-v2');
    static PED = new CourseDetails(AvailableCourses.PED, 'Podstawy Efektywnego Działania', 'Witamy na Kursie "Podstawy Efektywnego Działania"', '1 tydzień', pedCourseStructure,
        pedDescription, '/produkt/podstawy-efektywnego-dzialania');
    static ZN = new CourseDetails(AvailableCourses.ZN, 'Zrozumieć Nastolatka', 'Witamy na Kursie "Zrozumieć Nastolatka"', '1 tydzień', znCourseStructure,
        znDescription, '/produkt/zrozumiec-nastolatka');
    static SPC = new CourseDetails(AvailableCourses.SPC, 'System Planowania Czasu', 'Witamy w Systemie Planowania Czasu!', '5 lekcji', spcCourseStructure,
        spcDescription, '/produkt/system-planowania-czasu', 'https://vimeo.com/1176634192');

    constructor(key: AvailableCourses, fullName: string, welcomeMessage: string, length: string, structure: LearningCourseWeek[], description: JSX.Element, dashboardUrl: string, introVideoUrl?: string) {
        this.key = key;
        this.fullName = fullName
        this.welcomeMessage = welcomeMessage
        this.length = length;
        this.structure = structure;
        this.description = description
        this.dashboardUrl = dashboardUrl
        this.introVideoUrl = introVideoUrl;
    }

    toString() {
        return this.key
    }

    static getDetailsByCourseName(name: AvailableCourses): CourseDetails | null {
        const allProps = Object.keys(this) as Array<keyof typeof CourseDetails>;
        for (const prop of allProps) {
            const value = this[prop];
            if (value instanceof CourseDetails && value.key === name) {
                return value;
            }
        }
        return null;
    }
}